/* eslint no-unused-vars: 0 */

/**
 * This file was automatically generated by ruby_to_typescript.rake.
 * Do not modify it by hand.
 */
export enum RfpPartnershipModel {
  SPONSORED_RESEARCH = "SPONSORED_RESEARCH",
  GIFT = "GIFT",
  CO_DEVELOPMENT = "CO_DEVELOPMENT",
  SUPPLY_PURCHASE = "SUPPLY_PURCHASE",
  LICENSING = "LICENSING",
  FEE_FOR_SERVICE = "FEE_FOR_SERVICE",
  EQUITY_INVESTMENT = "EQUITY_INVESTMENT",
  EMPLOYMENT = "EMPLOYMENT",
  PILOT_TRIAL_ENGAGEMENT = "PILOT_TRIAL_ENGAGEMENT",
}
